// src/components/DataFetcher/DataFetcher.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Reusable DataFetcher component
const DataFetcher = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('jwtToken'); // Retrieve the JWT token from localStorage
      if (!token) {
        console.error('Debug: No JWT token found in localStorage');
      }

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token to the Authorization header
          },
        });
        setData(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Debug: DataFetcher error:', err);
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data: {error.message}</div>;
  }

  return children(data);
};

export default DataFetcher;
